import { getDateRangeTextInEastern } from '@general/dates';
import { transformLocation } from '@general/location';

export const mapSearchEventToProps = ({ hit, isFavorite, onClick }) => {
    const id = parseInt(hit.objectID.split('-')[1], 10);
    return {
        id,
        code: hit.event_code || null,
        title: hit.title,
        image: hit.image,
        // 2020-11-11
        beginsAt: hit.meeting_start_time,
        endsAt: hit.meeting_end_time,
        timezone: hit.timezone,
        url: `${window.location.protocol}//${window.location.hostname}${hit.url}`,
        address: hit.location?.address,
        city: hit.location?.city,
        stateProvince: hit.state_province,
        country: hit.location?.country,
        displayLocation: transformLocation({
            address: hit.location?.address,
            city: hit.location?.city,
            state: hit.location?.state,
            country: hit.location?.country,
        }),
        dateRange: getDateRangeTextInEastern(hit.meeting_start_time, hit.meeting_end_time),
        registrationOpen: hit.registration_open,
        registrationStartDate: hit.registration_start_date,
        isFavorite,
        onClick,
    };
};

export const mapSearchEventToPropsNew = ({ hit, isFavorite, onClick }) => {
    const id = parseInt(hit.objectID.split('-')[1], 10);

    return {
        event: {
            id,
            code: hit.event_code || null,
            title: hit.title,
            image: hit.image,
            beginsAt: hit.meeting_start_time,
            endsAt: hit.meeting_end_time,
            timezone: hit.timezone,
            dateRange: getDateRangeTextInEastern(hit.meeting_start_time, hit.meeting_end_time),
            url: `${window.location.protocol}//${window.location.hostname}${hit.url}`,
            address: hit.location?.address,
            city: hit.location?.city,
            stateProvince: hit.state_province,
            country: hit.location?.country,
            displayLocation: transformLocation({
                address: hit.location?.address,
                city: hit.location?.city,
                state: hit.location?.state,
                country: hit.location?.country,
            }),
            registrationOpen: hit.registration_open,
            registrationStartDate: hit.registration_start_date,
        },
        isFavorite,
        onClick,
    };
};

// graphQL
export const mapGraphEventToProps = event => ({
    id: event.recordId,
    code: event.code,
    title: event.title,
    // 2020-11-11T19:00:00+00:00
    beginsAt: event.beginsAt,
    endsAt: event.endsAt,
    url: `${window.location.protocol}//${window.location.hostname}${event.url}`,
    address: event.location ? event.location.address : null,
    city: event.location ? event.location.city : null,
    stateProvince: event.location ? event.location.stateProvince : null,
    country: event.location ? event.location.country : null,
    displayLocation: transformLocation({
        address: event.location?.address,
        city: event.location?.city,
        state: event.location?.stateProvince,
        country: event.location?.country,
    }),
    dateRange: getDateRangeTextInEastern(event.beginsAt, event.endsAt),
    isFavorite: event.isFavorite,
});

export const mapGraphEventToOldApi = event => {
    if (!event) {
        return null;
    }

    return {
        begins_at: event.beginsAt,
        building: {
            city: event.location?.city,
            country: {
                name: event.location?.country,
            },
            name: event.location?.address,
            state_province: {
                code: event.location?.stateProvince,
            },
        },
        code: event.code,
        ends_at: event.endsAt,
        image: event.image,
        record_id: event.recordId,
        title: event.title,
        url: event.url,
    };
};
